<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-12 d-block d-md-none">
            <router-link
              :to="'/'"
              class="btn-link font-weight-normal text-white"
              title="Voltar para o início"
              ><i class="fas fa-chevron-left mr-1"></i> Voltar</router-link
            >
          </div>
          <div class="col-lg-7 col-md-10">
            <p class="text-white my-3">
              Aqui você pode conferir o feed de publicações e impulsionar a
              interação entre colaboradores. Toda nova publicação aparecerá
              automaticamente na listagem abaixo.
            </p>
          </div>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--7">
      <div class="vld-parent" ref="news_feed">
        <div class="col-xl-8 col-lg-8 px-0">
          <new-post
            :profile_picture="profile_picture"
            :user="user"
            @news="loadInitialNews"
            endpoint="empresa"
          />
        </div>
        <div :key="event.id" v-for="(event, index) in news">
          <div class="post-card shadow col-xl-8 col-lg-12 mb-4 card px-2">
            <p class="mb-2 mt-2">
              <a @click="handleViewUser(event)" class="click-name">
                <img
                  width="30"
                  height="30"
                  v-if="event.profile_picture"
                  :src="event.profile_picture"
                  class="rounded-circle"
                  alt="foto de perfil"
                />
                <i v-else class="fas fa-user-circle user-default-logo"></i>
                <span class="ml-2">{{
                  event.collaborator_name
                    ? event.collaborator_name
                    : event.company_name
                }}</span>
              </a>
            </p>
            <img
              v-if="event.image_url"
              class="image-feed rounded mx-auto d-block col-12 px-0"
              :src="event.image_url"
              alt="..."
            />
            <quill-editor
              v-model="event.body"
              :options="editorReadOnly"
              disabled="disabled"
            >
            </quill-editor>
            <div class="btn-group m-3 d-flex border-group">
              <base-button
                disabled
                class="btn btn-white py-1"
                :title="
                  !event.liked ? 'A empresa não pode curtir' : 'Descurtir'
                "
              >
                <div v-if="!event.liked" class="">
                  <i class="far fa-heart fa-sm"></i>
                  {{ event.likes }}
                </div>
                <div v-else class="">
                  <i class="fas fa-heart fa-sm"></i>
                  {{ event.likes }}
                </div>
              </base-button>
              <base-button
                class="btn btn-white py-1"
                @click="$router.push(`/empresa/social/${event.id}/visualizar`)"
              >
                <i class="far fa-comment fa-sm"></i> {{ event.comments }}
              </base-button>
              <base-button
                v-tooltip="
                  news[index].status === 'public'
                    ? 'Oculte uma publicação que pode não estar de acordo.'
                    : 'Deixar publicação visível novamente.'
                "
                class="btn btn-white py-1"
                @click="handleSetStatus(index)"
              >
                <i
                  v-if="news[index].status === 'public'"
                  class="far fa-eye-slash"
                ></i>
                <i v-else class="far fa-eye"></i>
              </base-button>
            </div>
          </div>
        </div>
      </div>
      <div class="vld-parent" ref="scroll"></div>
    </div>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
import NewPost from "@/components/PostNew.vue";
import api from "@/services/api";

export default {
  name: "post_card",
  components: {
    NewPost,
    quillEditor
  },
  data() {
    return {
      news: [],
      meta: {},
      user: {},
      profile_picture: "",
      events: [],
      treinaments: [],
      dynamics: [],
      limit: 10,
      empty: {
        news: "",
        events: "",
        treinaments: "",
        dynamics: ""
      },
      editorReadOnly: {
        placeholder: "...",
        readOnly: true,
        theme: "bubble"
      }
    };
  },
  async mounted() {
    await this.loadInitialNews();
    await this.loadNews();
    await this.loadUser();
  },
  methods: {
    async loadUser() {
      try {
        const { data } = await api.get(`/company/companies`);
        if (data) {
          this.user = data;
          this.profile_picture = data.profile_picture
            ? data.profile_picture.url
            : "";
        }
      } catch (error) {
        this.$toasted.error("Falha ao recuperar usuário");
      }
    },
    loadNews() {
      window.onscroll = async () => {
        let bottomOfWindow =
          document.documentElement.scrollTop + window.innerHeight ===
          document.documentElement.offsetHeight;
        if (bottomOfWindow && this.meta.current_page < this.meta.last_page) {
          const loader = this.$loading.show({
            container: this.$refs.scroll,
            loader: "dots",
            width: 90,
            height: 90,
            opacity: 0
          });
          try {
            const {
              data: { data, meta }
            } = await api.get(
              `/company/news/?page=${this.meta.current_page + 1}`
            );
            if (data.length) {
              this.news = this.news.concat(data);
              this.meta = meta;
            } else this.empty.news = true;
            loader.hide();
          } catch (e) {
            this.$toasted.error(`Ocorreu um erro ao carregar as publicações`);
          }
        }
      };
    },
    async handleSetStatus(index) {
      let oldStatus = this.news[index].status;
      this.news[index].status =
        this.news[index].status === "public" ? "hidden" : "public";
      try {
        await api.patch(`/company/news/${this.news[index].id}/set-status`, {
          status: this.news[index].status
        });
      } catch (error) {
        this.news[index].status = oldStatus;
        this.$toasted.error("Falha ao ocultar a publicação");
      }
    },
    handleViewUser(news) {
      this.$router.push(
        news.collaborator_id
          ? `/empresa/colaboradores/${news.collaborator_id}/visualizar`
          : `/empresa/social/publicacoes`
      );
    },
    truncate(text, stop = 150, clamp = "...") {
      if (!text) return "N/A";
      return text.slice(0, stop) + (stop < text.length ? clamp : "");
    },
    async loadPublications(targetObjName, loaderRef, errorMsg) {
      this.empty[targetObjName] = false;
      const loader = this.$loading.show({
        container: loaderRef,
        loader: "dots",
        width: 90,
        height: 90,
        opacity: 0
      });
      try {
        const {
          data: { data, meta }
        } = await api.get(`/company/news`);
        if (data.length) {
          this.news = data;
          this.meta = meta;
        } else this.empty[targetObjName] = true;
        loader.hide();
      } catch (e) {
        this.$toasted.error(`Ocorreu um erro ao recuperar ${errorMsg}`);
      }
    },
    async loadInitialNews() {
      await this.loadPublications("news", this.$refs.news_feed, "as notícias");
    }
  }
};
</script>
<style scoped>
.card-image {
  width: 115px;
  height: 115px;
  border-radius: 10%;
  margin: auto;
}
.fab {
  color: #f6f9fc;
}
.image-feed {
  max-width: 500;
  max-height: 500;
}

.border-group {
  border-radius: 10px;
  border: 2px solid #eaeaea;
}

.post-card {
  border-radius: 10px;
  border: 1 px solid #e8e8e8;
}

.click-name {
  cursor: pointer;
}

.user-default-logo {
  font-size: 30px;
  vertical-align: middle;
}
</style>
<style>
p > strong {
  font-weight: bold !important;
}
</style>
